module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-22.905079f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-22.jpg
// module id = VM6+
// module chunks = 52